<form [formGroup]="formGroup">
  <div class="input-group">
    <ncp-input
      [options]="{
        id: 'test_control_1',
        inputClass: 'test',
        name: 'search',
        placeholder: 'search',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: search,
        onKeyUp: onKeyUp,
        onBlur: onBlur,
      }"
    />
    <ncp-button
      [options]="{
        class: 'iconButton',
        icon: 'bi bi-search',
        onClick: onClick,
      }"
    />
  </div>
</form>
